<template>
    <div id="stock_main" class="ui centered container">
        <div class="ui segment">
            <div class="ui text menu">
                <div class="menu">
                    <div class="item">
                        <div class="ui form">
                            <select class="ui simple dropdown" v-model="filter._center" @change="updateStockOrderList(1)">
                                <option v-for="c in getCenters()" :key="c._id" :value="c._id">{{ c.name }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="item">
                        <div v-if="partners && partners.length > 0" class="ui form">
                            <select class="ui simple dropdown" v-model="filter._partner" @change="updateStockOrderList(1)">
                                <option :key="null" :value="null">{{ "전체업체 "}}</option>
                                <option v-for="p in getAlivePartners()" :key="p._id" :value="p._id">{{ p.name }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="item">
                        <div class="ui form">
                            <select class="ui simple dropdown" v-model="filter.type" @change="updateStockOrderList(1)">
                                <option :value="undefined">입출고</option>
                                <option :value="constant.STOCK_ADD">{{ "입고" }}</option>
                                <option :value="constant.STOCK_REMOVE">{{ "출고" }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="item">
                        <div class="ui form">
                            <div class="field">
                                <div class="ui calendar" id="calendar_start">
                                    <div class="ui input left icon">
                                        <i class="calendar icon"></i>
                                        <input type="text" placeholder="날짜(부터)">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="ui form">
                            <div class="field">
                                <div class="ui calendar" id="calendar_end">
                                    <div class="ui input left icon">
                                        <i class="calendar icon"></i>
                                        <input type="text" placeholder="날짜(까지)">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="right menu">
                    <div v-if="isPartner || isHeader" class="item">
                        <button class="ui primary small button" @click="newStockOrderAdd">입고</button>
                    </div>
                    <div v-if="isPartner || isHeader" class="item">
                        <button class="ui primary small button" @click="newStockOrderRemove">출고</button>
                    </div>
                    <div class="item">
                        <button class="ui teal small button" @click="openDailyLog">날짜별 보기</button>
                    </div>
                    <div class="item">
                        <button class="ui teal small button" @click="download">다운로드</button>
                    </div>
                    <div class="item">
                        <button class="ui orange small icon button" @click="updateStockOrderList(1)">새로고침</button>
                    </div>
                </div>
            </div>
            <table class="ui selectable very basic table">
                <thead>
                    <tr>
                        <th class="collapsing">#</th>
                        <th>업체</th>
                        <th>유형</th>
                        <th>날짜</th>
                        <th>확정날짜</th>
                        <th>상품수</th>
                        <th>수량합계</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(stockOrder, index) in stockOrders" :key="stockOrder._id" :class="stockOrder.confirmedAt ? '' : 'yellow'">
                        <td class="collapsing">{{ index+1 }}</td>
                        <td>{{ getPartner(stockOrder._partner).name }}</td>
                        <td>{{ constantNames[stockOrder.type] }}</td>
                        <td>{{ new Date(stockOrder.createdAt).format("yy-MM-dd(KS) HH:mm") }}</td>
                        <td>{{ stockOrder.confirmedAt ? new Date(stockOrder.confirmedAt).format("yy-MM-dd(KS) HH:mm") : "미확정" }}</td>
                        <td>{{ stockOrder.products.length }}</td>
                        <td>{{ stockOrder.totalCount }}</td>
                        <td class="right collapsing">
                            <div class="ui small icon buttons">
                                <button :class="stockOrder == selected ? 'ui grey button' : 'ui basic button'" @click="showStockOrder(stockOrder)">
                                    <i class="file outline icon"></i>
                                </button>
                                <button class="ui basic button" @click="deleteStockOrder(stockOrder)" v-if="!stockOrder.confirmedAt">
                                    <i class="trash icon"></i>
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="ui centered pagination menu">
                <a :class="page == 1 ? 'active item' : 'item'" @click="updateStockOrderList(1)">1</a>
                <a :class="page == 2 ? 'active item' : 'item'" @click="updateStockOrderList(2)">2</a>
                <a :class="page == 3 ? 'active item' : 'item'" @click="updateStockOrderList(3)">3</a>
                <a :class="page == 4 ? 'active item' : 'item'" @click="updateStockOrderList(4)">4</a>
                <a :class="page == 5 ? 'active item' : 'item'" @click="updateStockOrderList(5)">5</a>
                <a :class="page == 6 ? 'active item' : 'item'" @click="updateStockOrderList(6)">6</a>
                <a :class="page == 7 ? 'active item' : 'item'" @click="updateStockOrderList(7)">7</a>
                <a :class="page == 8 ? 'active item' : 'item'" @click="updateStockOrderList(8)">8</a>
                <a :class="page == 9 ? 'active item' : 'item'" @click="updateStockOrderList(9)">9</a>
                <a :class="page == 10 ? 'active item' : 'item'" @click="updateStockOrderList(10)">10</a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data: function() {
        return {
            stockOrders: 0,
            filter: 0,
            selected: 0,
            page: 0,
            totalPages: 0,
        };
    },
    created: function() {
        this.page = 1;
        this.filter = {};
        this.filter._partner = (this.isPartner) ? this.user._id : null;
        this.filter._center = (this.centers) ? this.getCenters()[0]._id : null;
        this.updateStockOrderList(1);
    },
    mounted: function() {
        this.$ui.calendar_StartEnd("#calendar_start", "#calendar_end",
            (date, text) => { this.filter.dateStart = text; },
            (date, text) => { this.filter.dateEnd = text; this.updateStockOrderList(1); });
    },
    methods: {
        updateStockOrderList(page)
        {
            this.$event.call("openLoading");
            this.$api.getStockOrderList(page ? page : this.page, this.filter, (resData) => {
                this.$event.call("closeLoading");

                this.page = resData.page;
                this.totalPages = resData.totalPages;
                if (resData.error) {
                    alert(resData.error.message);
                } else {
                    this.showModal = true;
                    this.stockOrders = resData.stockOrders;
                    this.products = resData.products;
                }
            });
        },
        newStockOrderAdd()
        {
            if (this.filter._partner && this.filter._center)
            {
                this.$event.call("newStockOrder_add",
                    this.getCenter(this.filter._center),
                    this.getPartner(this.filter._partner),
                    this.getPartnerProducts(this.filter._partner),
                    this.updateStockOrderList);
            }
            else
            {
                alert("업체를 선택하세요!");
            }
        },
        newStockOrderRemove()
        {
            if (this.filter._partner && this.filter._center)
            {
                this.$event.call("newStockOrder_remove",
                    this.getCenter(this.filter._center),
                    this.getPartner(this.filter._partner),
                    this.getPartnerProducts(this.filter._partner),
                    this.updateStockOrderList);
            }
            else
            {
                alert("업체를 선택하세요!");
            }
        },
        showStockOrder(stockOrder)
        {
            this.selected = stockOrder;
            this.$event.call("stockOrderDetail_open", {
                stockOrder: stockOrder,
                center: this.getCenter(this.filter._center),
                partner: this.getPartner(stockOrder._partner),
                partnerProducts: this.getPartnerProducts(stockOrder._partner),
                onChange: this.updateStockOrderList,
            });
        },
        deleteStockOrder(stockOrder)
        {
            if (!stockOrder.confirmedAt)
            {
                this.$event.call("openPopup", "삭제하시겠습니까?", "", () => {
                    this.$api.deleteStockOrder(stockOrder._id, resData => {
                        this.updateStockOrderList();
                    });
                });
            }
        },
        openDailyLog()
        {
            if (this.filter._partner)
            {
                this.$event.call("openStockDaliyLog",
                    this.getPartner(this.filter._partner),
                    this.getCenter(this.filter._center));
            }
            else
            {
                alert("업체를 선택하세요!");
            }
        },
        getPartner(_partnerId)
        {
            for (const partner of this.partners)
            {
                if (partner._id == _partnerId)
                {
                    return partner;
                }
            }
            return null;
        },
        getPartnerProducts(_partnerId)
        {
            const partnerProducts = [];

            for (const product of this.products)
            {
                if (product._partner == _partnerId)
                {
                    partnerProducts.push(product);
                }
            }
            return partnerProducts;
        },
        getCenter(_centerId)
        {
            for (const center of this.centers)
            {
                if (center._id == _centerId)
                {
                    return center;
                }
            }
            return null;
        },
        getAlivePartners()
        {
            const array = [];
            for (const partner of this.partners)
            {
                if (!partner.isTerminated) array.push(partner);
            }
            return array;
        },
        getAlivePartners()
        {
            const array = [];
            for (const partner of this.partners)
            {
                if (!partner.isTerminated) array.push(partner);
            }
            return array;
        },
        getCenters()
        {
            const array = [];
            for (const center of this.centers)
            {
                if (!center.isTerminated) array.push(center);
            }
            return array;
        },
        download()
        {
            this.$event.call("openLoading");
            this.$api.getAllStockOrders(this.filter, (resData) =>
            {
                this.$event.call("closeLoading");
                if (resData.error) {
                    alert(resData.error.message);
                } else if (resData.stockOrders) {
                    const centerName = this.getCenter(this.filter._center).name;
                    const partnerName = (this.filter._partner) ? this.getPartner(this.filter._partner).name : "전체업체";
                    const typeName = (this.filter.type) ? this.constantNames[this.filter.type] : "입출고";
                    this.$excel.downloadStockOrders(this, resData.stockOrders, centerName + "_" + typeName + "내역_" + partnerName);
                }
            });
        }
    },
    computed: {
        user: function() { return this.$store.getters.user; },
        isHeader: function() {return this.$store.getters.isHeader; },
        isPartner: function() {return this.$store.getters.isPartner; },
        isCenter: function() {return this.$store.getters.isCenter; },
        partners: function() { return this.$store.getters.partners; },
        centers: function() {return this.$store.getters.centers; },
        constant: function() {return this.$store.getters.constant; },
        constantNames: function() {return this.$store.getters.constantNames; },
        products: {
            get: function() { return this.$store.getters.products; },
            set: function(val) { this.$store.commit("setProducts", val); },
        },
    },
}
</script>

<style>
#stock_main {
    margin-top:15px;
    min-width:1400px;
    min-height: 800px;
}

#stock_main .ui.text.menu {
    margin: 0;
    width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/StockMain.vue